import { Link, useLocation } from 'react-router-dom';

export const NotFoundPage = () => {
  const { pathname } = useLocation();
  return (
    <section className="content-header">
      <h1>Страница не найдена</h1>
      <p className="text-muted">{pathname}</p>
      <p>
        <Link to="/users" className="btn btn-primary">
          К пользователям
        </Link>
      </p>
    </section>
  );
};
